module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-27.394b778a.png";